import {Injectable} from "@angular/core";
import {environment} from "../environments/environment";
import config from "../../config/config.json"

export interface AppConfig {
  apiUrl?: string,
  keycloak: {
    config: Keycloak.KeycloakConfig,
    initOptions: {
      checkLoginIframe: boolean
    }
  }
}

@Injectable()
export class AppService {

  static getConfig(): AppConfig {
    const urlOrigin = window.location.origin
    for (const [key, configData] of Object.entries(config)) {
      for (const url of Object.values(configData.urls)) {
        if (url.includes(urlOrigin)) {
          return {
            apiUrl: configData.apiUrl || origin + '/infoportal',
            keycloak: {
              config: configData.keycloak.config,
              initOptions: {
                checkLoginIframe: configData.keycloak.initOptions.checkLoginIframe,
              }
            }
          }
        }
      }
    }
    return {
      apiUrl: environment.settings.apiUrl || origin + '/infoportal',
      keycloak: {
        config: environment.keycloak,
        initOptions: {
          checkLoginIframe: environment.checkLoginIframe
        }
      }
    }
  }
}
